import { getAssets, HydrationScript } from 'solid-js/web';

export function IndexHtml(props)
{
	const buildLink = props.build.storeForBuiltAssets == 'production' ? '_build' : '_devBuild';

	/* Needs to be separated from the JSX, otherwise the SSR interferes for some reason. */
	const basicData = `
		window.build = ${JSON.stringify(props.build)};
		window.site = ${JSON.stringify(props.site)};
		window.user = ${JSON.stringify(props.user.toJson())};
	`;

	return (
		<html lang='en'>
			<head>
				<meta charset='UTF-8' />
				<meta name='viewport' content='width=device-width, initial-scale=1.0' />
				<meta http-equiv='Content-type' content='text/html; charset=utf-8'/>

				{getAssets()}

				<HydrationScript />
			</head>
			<body>
				{props.children}

				<script>{basicData}</script>
				<script type='module' src={`/${buildLink}/${props.build.key}/BrowserApp.js`} />
			</body>
		</html>
	);
}

